import type { ReactNode } from 'react';

type BottomSheetProps = {
  title?: string;
  children: ReactNode;
};

// Persistent bottom sheet, mirroring the rider app's single-map + sheet pattern.
export function BottomSheet({ title, children }: BottomSheetProps) {
  return (
    <div className="bottom-sheet">
      <div className="sheet-grabber" />
      {title && <h2 className="sheet-title">{title}</h2>}
      <div className="sheet-body">{children}</div>
    </div>
  );
}
